"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = {}, action) => {
    if (action.audience) {
        return action.audience;
    }
    return state;
};
exports.getAudience = (state) => state;
exports.getTotalAudienceSize = (state) => state.totalSize || 0;
